import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { IndexPage } from './pages/IndexPage';
import { ExtensionPage } from './pages/ExtensionPage';
import { DevHarnessPage } from './pages/DevHarnessPage';
import './ui/styles.css';

// Hash routing: works on any static host with zero configuration.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/dev/:id" element={<DevHarnessPage />} />
        <Route path="/:id" element={<ExtensionPage />} />
      </Routes>
    </HashRouter>
  </StrictMode>,
);
